export default "__VITE_ASSET__BV5niHwM__"